import { FC, useEffect, useState } from "react";
import { Button, Card, Row, Space } from "antd";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { clsx } from "clsx";
import { usePDF } from "react-to-pdf";
import { Sanitized } from "../../../common/components/Sanitized";
import { handleError } from "../../../common/ErrorHandling";
import { getTacticById } from "../../../common/api/TacticClient";
import { Tactic } from "../../../types/TacticTypes";
import { SvgIcon } from "../../../common/components/SvgIcon";
import { PdfLayout } from "../../../common/components/PdfLayout";
import { useAppShellContext } from "../../layout/AppShell";
import { TacticContent } from "./TacticContent";
import classes from "./TacticView.module.less";

export const TacticView: FC = () => {
    const params = useParams();
    const [tactic, setTactic] = useState({} as Tactic);
    const { getContentContainer } = useAppShellContext();
    const { toPDF, targetRef } = usePDF();
    const [creating, setCreating] = useState(false);

    const tacticId = Number(params.id);

    const sections = tactic.contentV1?.map((item, index) => ({
        label: item.key
            .replace(/<[^>]*>/g, "")
            .replace(/[\t\n\r\f\v]/g, "")
            .trim()
            .replace(/^(\d\. *)/, "0$1"),
        value: item.value.replace(
            /^(<h2[^>]*>\s*<strong[^>]*>.*?)(\d)(\..*?<\/strong>\s*<\/h2>)/,
            "$10$2$3"
        ),
        key: index.toString(),
    }));

    const loadData = async () => {
        if (!tacticId) return;
        try {
            const data = await getTacticById(tacticId);
            setTactic(data);
        } catch (error) {
            handleError(error);
        }
    };
    useEffect(() => {
        loadData();
    }, [tacticId]);

    const createPdf = async () => {
        try {
            setCreating(true);
            await toPDF({
                page: { format: [400, targetRef.current.offsetHeight * 0.2645833333] },
                resolution: 1,
                canvas: { useCORS: true },
            });
        } catch (error) {
            handleError(error);
        } finally {
            setCreating(false);
        }
    };

    const pdfContent = (
        <div ref={targetRef} style={{ position: "fixed", left: "-1000rem" }}>
            <PdfLayout style={{ width: "400mm", height: "auto", gap: "1rem" }}>
                {sections?.map((item, index) => (
                    <Sanitized
                        key={index}
                        className={clsx("il-summary", classes.summary)}
                        content={item.value}
                    />
                ))}
            </PdfLayout>
        </div>
    );

    return (
        <Card bordered={false} className={classes.container}>
            <div className={classes.header}>
                <Link to="/tactic">
                    <Space align="center" className={classes.back}>
                        <SvgIcon name="back" />
                        Back
                    </Space>
                </Link>
                <Row justify="space-between" align="middle" className={classes.titleRow}>
                    <div className={classes.title}>{tactic.name}</div>
                    <Button type="primary" size="large" onClick={createPdf} loading={creating}>
                        Create PDF
                    </Button>
                </Row>
            </div>
            {pdfContent}
            <TacticContent
                tactic={tactic}
                onTabChange={() => getContentContainer()?.scrollTo({ top: 0, behavior: "smooth" })}
            />
        </Card>
    );
};
